import { Link } from 'gatsby';
import React from 'react';
import { useImage } from '../../../shared/hooks/useImage';

const UseCase = ({ content }) => {
  const { image, header, overview, industry, region, cta_url: ctaUrl } = content;
  const img = useImage(image);
  return (
    <div className='use-case'>
      {img}
      <div className='bottom-card'>
        <h3>{header}</h3>
        <p>
          <strong>Overview:</strong> {overview}
        </p>
        <p>
          <strong>Industry:</strong> {industry}
        </p>
        <p>
          <strong>Region:</strong> {region}
        </p>
        <Link className='card-link link--arrow right--arrow' to={ctaUrl}>
          See the Usecase
        </Link>
      </div>
    </div>
  );
};

function UseCases({ useCases, className }) {
  return (
    <div className={className}>
      {useCases.map(useCase => (
        <UseCase key={useCase.header} content={useCase} />
      ))}
    </div>
  );
}

export default UseCases;
